import { useState, useRef } from "react";

import scratchicon from '../img/scratchicon.svg';


function ContentInspector(props) {
  const { content } = props;
  const [pos, setPos] = useState({ x: -9999, y: -9999 });
  const [visible, setVisible] = useState(false);
  const containerRef = useRef(null);

  const bubbleRadius = 80; // px
  const offsetX = -20;
  const offsetY = -60;

  const getCoords = (e) => {
    const rect = containerRef.current.getBoundingClientRect();
    const x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
    const y = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;
    return { x, y };
  };

  const handleStart = (e) => {
    const { x, y } = getCoords(e);
    setPos({ x, y });
    setVisible(true);
    props.showButtons(false);
  };

  const handleMove = (e) => {
    if (!visible) return;
    const { x, y } = getCoords(e);
    setPos({ x, y });
  };

  const handleEnd = () => {
    setVisible(false);
    props.showButtons(true);
  };

  const cx = pos.x + offsetX;
  const cy = pos.y + offsetY;

  return (
    <div
      ref={containerRef}
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        touchAction: "none",
      }}
      onMouseDown={handleStart}
      onMouseMove={handleMove}
      onMouseUp={handleEnd}
      onMouseLeave={handleEnd}
      onTouchStart={handleStart}
      onTouchMove={handleMove}
      onTouchEnd={handleEnd}
      className="page-content-inspector"
    >

      <div className={`scratchicon ${visible && "scratchiconremoved"}`} ><img src={scratchicon} className='scratchiconimg' /></div>

      {/* Background always visible */}
      <div
        style={{
          backgroundImage: `url(${props.baseurl + content?.backgroundurl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "absolute",
          inset: 0,
        }}
      />

      {/* Inner image, only visible inside bubble (with fade) */}
      <div
        style={{
          backgroundImage: `url(${props.baseurl + content?.innerimageurl})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "absolute",
          inset: 0,
          WebkitMaskImage: visible
            ? `radial-gradient(circle ${bubbleRadius}px at ${cx}px ${cy}px, rgba(0,0,0,1) 80%, rgba(0,0,0,0) 100%)`
            : "radial-gradient(circle 0px at 0 0, transparent, transparent)", // fully hidden
          WebkitMaskRepeat: "no-repeat",
          WebkitMaskSize: "100% 100%",
          maskImage: visible
            ? `radial-gradient(circle ${bubbleRadius}px at ${cx}px ${cy}px, rgba(0,0,0,1) 80%, rgba(0,0,0,0) 100%)`
            : "radial-gradient(circle 0px at 0 0, transparent, transparent)",
          maskRepeat: "no-repeat",
          maskSize: "100% 100%",
          pointerEvents: "none",
          opacity: visible ? 1 : 0,
          transition: "WebkitMaskImage 0.25s ease, mask-image 0.25s ease, opacity 0.2s",
        }}
      />
    </div>
  );
}

export default ContentInspector;
